import { polarToCartesian } from "./polar-to-cartesian";
export var pointAtOrigin = function (x, y) {
  return function (radius, angleInDegrees) {
    return polarToCartesian(x, y, radius, angleInDegrees);
  };
};